const BlogApi = [
  {
    id: 1,
    image: "https://i.postimg.cc/x89dn67P/Screenshot-2022-08-03-194142.png",
    date: "19 Feb, 2022",
    title_one: "My first three week experience at Masai School.",
    Link_to_blog: "https://medium.com/@surajbadwaik0309/my-first-three-weeks-experience-at-masai-school-3a48ad501b82"
  },
  {
    id: 2,
    image: "https://i.postimg.cc/J7PWg71g/Screenshot-2022-08-03-194223.png",
    date: "2 Apr, 2022",
    title_one: "My first project at Masai School.",
    Link_to_blog: "https://medium.com/@surajbadwaik0309/masai-group-project-1-3d7325d89cd2"
  },
  {
    id: 3,
    image: "https://i.postimg.cc/kMxyXDV1/Screenshot-2022-08-03-194257.png",
    date: "9 May, 2022",
    title_one: "My second project - Cloning of Nordstorm.com.",
    Link_to_blog: "https://medium.com/@surajbadwaik0309/masai-group-project-2-nordstrom-com-2c7bd674898b"
  },
 

]
export default BlogApi
